import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence, motion, useScroll, useSpring } from "framer-motion";
import { MessageCircle } from "lucide-react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Fleet } from "@/components/site/Fleet";
import { Coverage } from "@/components/site/Coverage";
import { Testimonials } from "@/components/site/Testimonials";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";
import { BRAND } from "@/data";

function App() {
  const [showFab, setShowFab] = useState(false);
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onScroll = () => setShowFab(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const scrollToReserve = () =>
    document.querySelector("#reservation")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="App noise-overlay bg-[#060B14]">
      <motion.div
        data-testid="scroll-progress"
        style={{ scaleX: progress }}
        className="fixed top-0 left-0 right-0 h-[3px] bg-champagne origin-left z-[70]"
      />
      <Navbar onReserve={scrollToReserve} />
      <main>
        <Hero onReserve={scrollToReserve} />
        <Marquee />
        <Services onReserve={scrollToReserve} />
        <Manifesto />
        <Fleet />
        <Coverage />
        <Testimonials />
        <Booking />
      </main>
      <Footer />

      <AnimatePresence>
        {showFab && (
          <motion.a
            data-testid="floating-whatsapp"
            href={`https://wa.me/${BRAND.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            whileHover={{ scale: 1.08 }}
            className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-champagne text-[#060B14] flex items-center justify-center shadow-lg shadow-black/40"
            aria-label="Contacter sur WhatsApp"
          >
            <MessageCircle size={24} />
          </motion.a>
        )}
      </AnimatePresence>

      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
